import { createSelector } from 'reselect';
import { RootState } from '@/store';

const getRegistry = (state: RootState) => state.registry;

export const getIsZolaGiftCardEnabled = createSelector(
  getRegistry,
  (registry) => registry.default_gift_card_enabled
);
